import { combineReducers } from 'redux';
import holidayBorderLeft from './holidayBorderLeft';
import holidayBorderRight from './holidayBorderRight';

export default combineReducers({
  holidayBorderLeft,
  holidayBorderRight,
});
